import React, { useState, useEffect } from "react";

import Navbar from "../components/Layout/Navbar";
import { Link } from "react-router-dom";
import Footer from "../components/Layout/Footer";
import CustomHelmet from "../components/CustomHelmet";
import Fade from "react-reveal/Fade";
import { Alert, Spinner } from "react-bootstrap";
import contactImage from "../images/contact.png";
import axios from "axios";

const url =
  "https://www.hubsquares.com/php_files/processContact.php/";

export default function Contact(props) {
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [spin, setSpin] = useState(false);
  const [error, setError] = useState(false);
  const [errorValue, setErrorValue] = useState("");
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  async function handleSubmit(e) {
    if (message !== "" && subject !== "" && email !== "") {
      setSpin(true);
      e.preventDefault();
      const formData = new FormData();
      formData.append("email", email);
      formData.append("subject", subject);
      formData.append("message", message);
      await axios
        .post(url, formData, {
          headers: {
            "content-type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          if (data.success === 1) {
            setSuccess(true);
            setErrorValue(data.msg);
            setError(false);
            setMessage("");
            setSpin(false);
            setEmail("");
            setSubject("");
          } else if (data.success === 0) {
            setErrorValue(data.msg);
            setError(true);
            setSuccess(false);
            setSpin(false);
          }
        });
    } else {
      setError(true);
      setErrorValue("All fields are required");
    }
  }
  useEffect(() => {
    if (error || success) {
      setTimeout(() => {
        setError(false);
        setSuccess(false);
        setErrorValue("");
      }, 5000);
    }
  }, [error, success]);
  return (
    <div>
      <CustomHelmet page="Contact Us" />
      <Navbar search={true} props={props} user={props.user} />

      <div className="wrapper banner2 position-relative mh-new">
        <div className="overlay">
          <div className="banner">
            <div className="content text-left mt-6 container">
              <h1>CONTACT US</h1>
            </div>
          </div>
        </div>
      </div>

      <main className="container">
        <div className="navigation my-5">
          <p>
            <Link to="/" className="home">
              Home
            </Link>{" "}
            | <span> Contact Us</span>
          </p>
        </div>

        <div className="row py-5">
          <div className="col-md-6">
            <h2 className="mb-5">Contact Us</h2>
            <img src={contactImage} width="100%" alt="hubsquares contact" />
          </div>
          <div className="col-md-6">
            <h2 className="pb-4 border-bottom">Send Us a Message</h2>
            <form className="pt-4">
              <div className="form-group">
                <input
                  type="email"
                  className="form-control form-control-lg"
                  placeholder="Email:"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="form-group">
                <input
                  className="form-control form-control-lg"
                  type="text"
                  placeholder="Subject:"
                  value={subject}
                  required
                  onChange={(e) => setSubject(e.target.value)}
                />
              </div>
              <div className="form-group">
                <textarea
                  className="form-control"
                  placeholder="Message:"
                  rows="6"
                  value={message}
                  required
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
              </div>
              <button
                type="submit"
                className="btn btn-danger btn-lg rad-0 addbtn"
                onClick={(e) => handleSubmit(e)}
                disabled={spin}
              >
                Send Messages
                {spin && (
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                )}
              </button>
            </form>
            <div className="my-2">
              {error && (
                <Fade bottom collapse when={error}>
                  <Alert variant="danger">{errorValue}</Alert>
                </Fade>
              )}
              {success && (
                <Fade bottom collapse when={success}>
                  <Alert variant="success">{errorValue}</Alert>
                </Fade>
              )}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
